<template>
  <header class="app-header">
    <div class="bread-container">
      <span
        class="iconfont icon-qiehuan toggle-icon"
        :class="[sidebarCollapse ? '' : 'is-collapse']"
        @click="toggleSidebar"
      ></span>
      <breadcrumb></breadcrumb>
    </div>
  
    <div class="row-v">
    <el-dropdown
      :hide-on-click="false"
      placement="bottom-start"
      @command="handleCommand"
      id="userCenter"
    >
      <div class="username">{{ user }}</div>
      <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="user">
            <i class="el-icon-switch-button"></i>
            修改密码
          </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="logout" @click="logout">退出登录</div>
    </div>
    <!-- <el-dropdown :hide-on-click="false" placement="bottom-start" @command="handleCommand">
      <div class="el-dropdown-link">
        <img src="../../assets/images/avatar.jpg" alt="头像" class="avatar" />
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu slot="dropdown">
       <el-dropdown-item icon="el-icon-s-custom" command="user">个人中心</el-dropdown-item>
    <el-dropdown-item icon="el-icon-eleme" command="logout"></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    
    <user-center :show-dialog.sync="showDialog" ref="user"></user-center>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb";
import UserCenter from "@/components/UserCenter/UserCenter";//修改密码的弹窗组件
export default {
  name: "AppHeader",
  data() {
    return {
      user: null,
      showDialog: false,//弹窗默认关闭
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`
      }
    };
  },
  components: {
    Breadcrumb,
    UserCenter
  },
  computed: {
    ...mapGetters(["sidebarCollapse"])
    //计算用户头像，如果有就加载，没有就使用默认的
    // 'img_src': function() {
    //   // if (this.user) {
    //   //   return this.user.avatar !== null ? this.user.avatar : "../../assets/images/avatar.gif";
    //   // }
    //   return "../../assets/images/avatar.gif";
    // }
  },
  mounted() {
    //组件挂载完毕
    //this.user = this.$store.getters.getUserInfo.user;
    this.user = JSON.parse(sessionStorage.getItem("userinfo")).nickname
  },
  methods: {
    logout() {
      sessionStorage.clear(); //清除token
      this.$store.dispatch("user/logout"); //清除状态管理
      this.$router.push("/login"); //跳转到登录页
      this.$toast("success", "已退出登录");
    },
    // 切换侧边栏
    toggleSidebar() {
      this.$store.dispatch("settings/changeSetting", {
        key: "sidebarCollapse"
      });
    },
    // 点击下拉菜单项的回调
    // handleCommand(command) {
    //   if (command === "logout") {
    //     this.logout();
    //   }
    // },
    // 点击下拉菜单项的回调
    handleCommand(command) {
      if (command === "logout") {
        this.logout();
      } else if (command === "user") {
        this.showDialog = true;
        // this.$refs["user"].getAdminInfo(); //获取个人信息
      }
    },
    toLogout() {
      this.logout();
    }
  }
};
</script>

<style lang="scss" scoped>
.username{
  margin-right: 20px;
  font-weight: 600;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 15px;
  color: #0b2849;
}
.row-v{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.logout {
  height: 100%;
  line-height: 100%;
  margin-right: 20px;
  font-weight: 600;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  font-size: 13px;
  color: #74abeb;
  cursor: pointer;
}
.logout:hover {
  color: #3374be;
}
.app-header {
  display: flex;
  height: 0.6rem;
  padding: 0 0.2rem;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .bread-container {
    display: flex;
    align-items: center;
  }
  .right-menu {
    line-height: 0.6rem;
    border: none;
  }
  .toggle-icon {
    margin-right: 0.1rem;
    font-size: 0.2rem;
    cursor: pointer;
  }
  .is-collapse {
    transform: rotate(180deg);
  }
  .el-dropdown-link {
    .avatar {
      width: 0.4rem;
      border-radius: 0.1rem;
      vertical-align: middle;
      cursor: pointer;
    }
    i {
      vertical-align: bottom;
      margin-bottom: 0.1rem;
    }
  }
}
</style>
